import {
    ButtonGroup, HStack,
} from '@chakra-ui/react';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { UsePaginationLabelReturn } from './hooks';
import { PageControlButton } from './components/page-control-button';
import { PageEllipsis } from './components/page-ellipsis';
import { PageButton } from './components/page-button';
import { usePagination, UsePaginationReturn } from './hooks/use-pagination';

// Add variant to Pagination theme

export function Pagination({
    width = 5,
    currentPage,
    totalPages,
    hasNextPage,
    hasPreviousPage,
    handleNext,
    handlePrevious,
    handleCurrent,
}: { width?: number } & UsePaginationLabelReturn) {
    const pages = usePagination({
        width,
        currentPage,
        totalPages,
    });

    if (totalPages <= 1) return null;

    return (
        <HStack
            border="1px solid"
            borderColor="muted.50"
            borderRadius="md"
            bgColor="white"
            w="fit-content"
            h="fit-content"
        >
            <ButtonGroup spacing={1} p={1} size="xs" alignItems="center">
                <PageControlButton
                    size="xs"
                    isDisabled={!hasPreviousPage}
                    icon={faChevronLeft}
                    onClick={handlePrevious}
                />
                {
                    pages.map((page: UsePaginationReturn, index) => {
                        if (page.type === 'page' && page.pageNumber !== undefined) {
                            return (
                                <PageButton
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={index}
                                    pageNumber={page.pageNumber}
                                    isActive={currentPage === page.pageNumber}
                                    onClick={() => handleCurrent(page.pageNumber ?? 0)}
                                />
                            );
                        }

                        // eslint-disable-next-line react/no-array-index-key
                        return <PageEllipsis key={index} />;
                    })
                }
                <PageControlButton
                    size="xs"
                    isDisabled={!hasNextPage}
                    icon={faChevronRight}
                    onClick={handleNext}
                />
            </ButtonGroup>
        </HStack>
    );
}
